import { MAIN_ROUTES } from '@Types/routes';

export default function isGeneralSettingsTab(pathname: string) {
	const regex = new RegExp(`general-settings|^/$|^${MAIN_ROUTES.Admin}$`);
	return regex.test(pathname);
}
